import { PRODUCTION, DEVELOPMENT, LOCAL_SUPPLY_CHAIN_URL } from "./const";
import { isEmpty } from "lodash";

export function getSupplyChainUrl() {
  const REACT_ENV = process.env.NODE_ENV;
  const SUPPLY_CHAIN_URL =
    !!process.env.REACT_APP_SUPPLY_CHAIN_URL && process.env.REACT_APP_SUPPLY_CHAIN_URL !== "" ? process.env.REACT_APP_SUPPLY_CHAIN_URL : LOCAL_SUPPLY_CHAIN_URL;
  if (!isEmpty(REACT_ENV)) {
    switch (REACT_ENV) {
      case DEVELOPMENT:
        return SUPPLY_CHAIN_URL;
      case PRODUCTION:
        return SUPPLY_CHAIN_URL;
      default:
        return SUPPLY_CHAIN_URL;
    }
  } else {
    return LOCAL_SUPPLY_CHAIN_URL;
  }
}

export const getSupplyChainUrlValue = () => {
  return getSupplyChainUrl();
};
